import { cartAtom } from "core/cart";
import { cn } from "core/shared";
import { userAtom } from "core/user";
import { BaseLink, Cart } from "~/design-system/components";
import { headerMenuAtom, searchAtom } from "~/modules/shared/atoms";
import { URLS } from "~/shared/urls";

export function CartHeaderLink() {
  const userTotalCart = userAtom.use("totalCart");
  const cart = cartAtom.use("cart");
  const cartTotalItems = userTotalCart || (cart && cart.items?.length) || 0;

  return (
    <BaseLink
      to={URLS.cart.root}
      onClick={() => {
        headerMenuAtom.close();
        searchAtom.close();
      }}
      className="relative block lg:hidden"
    >
      <Cart className="size-7" />
      {cartTotalItems > 0 && (
        <div
          className={cn(
            "animate-fade-in absolute top-0 right-0 size-2.5 rounded-full border bg-[#FF667E]",
          )}
        />
      )}
    </BaseLink>
  );
}
